import {useState} from 'react';
import { Container, Row } from 'react-bootstrap';
import {styles} from './SendPushNotification.component.style';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createPushNotification } from '../../redux/features/pushNotification/pushNotificationSlice';
import { useDispatch  } from 'react-redux';

const SendPushNotification = ({event}) => {
  const [title, setTitle] = useState("")
  const [body, setBody] = useState("")
  const dispatch = useDispatch();

  const onSendNotificatioClicked = () => {
    // check if all fields are filled
    if(title === "" || body === "" ){
      toast("Please fill all the fields!",{
        position: "top-center",
        type: "error"
      });
      return;
    }
    const requestBody = {
      title: title,
      body: body,
      game_id: event.id,
      city_id: event.city_id
    };
    dispatch(createPushNotification(requestBody));

    toast("Push notification sent successfully!",{
      position: "top-center",
      type: "success"
    });
    // clear the form
    setTitle("");
    setBody("");
  }

  return(
    <Container fluid style={styles.mainContainer}>
       <ToastContainer />
      <Container fluid style={styles.childContainer}>
        <Container fluid style={styles.container}>
          <Row style={styles.headerRow}>
            <text style={{fontSize:24}}>Send Push Notification</text>
            <text style={{fontSize:12}}>Send Push Notification to evenryone in this city except people already signed up to the event </text>
          </Row>
          <Row style={styles.inputRow}>
              <text style={styles.inputTitle}>Push Notification Title</text>
              <input style={styles.input} type="text" value={title} onChange={(e)=>{setTitle(e.target.value)}} required/>
          </Row>
          <Row style={styles.inputRow}>
                <text style={styles.inputTitle}>Push Notification Body Message</text>
                <input style={styles.input} type="text" value={body} onChange={(e)=>{setBody(e.target.value)}}/>
          </Row> 
        </Container>
        <Container fluid>
          <Row>
            <button style={styles.button} onClick={onSendNotificatioClicked}>Send Notification</button>
          </Row>
        </Container>
      </Container>
    </Container>
  )
}

export default SendPushNotification;